import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FormControl, FormHelperText, InputLabel, List, makeStyles, MenuItem, Select, Typography } from '@material-ui/core';

export default function RegisterSRNumber({ open, className, data, handleRegistration, handleClose,
                            // studentName, parentName, srNumber, mobileNumber, diseCode 
                          }) {
  const classes = useStyles();

  const [studentName, setStudentName] = useState('')
  const [parentName, setParentName] = useState('')
  const [classId, setClassId] = useState('')
  const [srNumber, setSRNumber] = useState('')
  const [mobileNumber, setMobileNumber] = useState('')
  const [diseCode, setDiseCode] = useState('')  

  const handleClickOpen = () => {
    // setOpen(true);
  };

  // const handleClose = () => {
    // setOpen(false);
  // };

  function renderClasses(){
    var classList = []
    data.map(item=>{
      classList.push(
        <MenuItem value={item.id}>{item.name}</MenuItem>
      )
    })
    return classList
  }

  return (
    <div>

      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        {/* <DialogTitle id="form-dialog-title">Subscribe</DialogTitle> */}
        <DialogContent>
          {/* <DialogContentText>
            To subscribe to this website, please enter your email address here. We will send updates
            occasionally.
          </DialogContentText> */}
          <TextField
            autoFocus
            margin="dense"
            id="stname"
            label="Student Name"
            fullWidth
            onChange={(e)=>{ setStudentName(e.target.value) }}
          />
          <FormControl className={classes.formControl}>
            <InputLabel id="demo-simple-select-helper-label">Class</InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={className}
              onChange={e=>{setClassId(e.target.value)}}
            >
              {}
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {renderClasses()}
              {}
            </Select>
            {/* <FormHelperText>Select Class </FormHelperText> */}
          </FormControl>

          <TextField
            autoFocus
            margin="dense"
            id="pName"
            label="Parent Name"
            type="email"
            fullWidth
            onChange={(e)=>{ setParentName(e.target.value) }}
          />
          <TextField
            autoFocus
            margin="dense"
            id="disc"
            label="SR Number"
            type="optional"
            fullWidth
            onChange={(e)=>{ setSRNumber(e.target.value) }}
          />
          <TextField
            autoFocus
            margin="dense"
            id="phno"
            label="Parent Mobile Number"
            type="phone"
            fullWidth
            onChange={(e)=>{ setMobileNumber(e.target.value) }}
          />
          <TextField
            autoFocus
            margin="dense"
            id="disc"
            label="Dise Code(optional)"
            type="optional"
            fullWidth
            onChange={(e)=>{ setDiseCode(e.target.value) }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={()=>handleRegistration(studentName, classId, parentName, srNumber, mobileNumber, diseCode )} color="primary">
            <Typography align="center">Enroll</Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));